"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLegacyWarningsEnabled = setLegacyWarningsEnabled;
exports.coerceLegacyOrIsoLanguage = coerceLegacyOrIsoLanguage;
/**
 * Legacy language-key adapter. THIS WHOLE FILE IS DEPRECATED and will be
 * deleted once Sentry confirms partners have stopped sending legacy values.
 * Do NOT add new callers.
 *
 * Two boundary surfaces may still receive legacy values from partner
 * deployments: the `language_g` URL param (decoded independently by
 * `server/bootstrap/api.ts` and `client/system/request-metadata.ts`'s
 * `useSiloLanguage`), and the per-user `admin_language` module global
 * (coerced on read by the `moderation.getQueueLanguage` handler in
 * `server/orpc/routers/moderation-language.ts`; writes always store ISO, so
 * legacy values self-heal on next save).
 *
 * Deletion-readiness signal: once console.error/Sentry stops seeing legacy
 * hits in production, delete this file and replace the boundary callers
 * above with `parseIsoLocale(x) ?? DEFAULT_ISO_LOCALE`.
 */
const locale_1 = require("./locale");
const LEGACY_TO_ISO = {
    english: 'en-US',
    french: 'fr-FR',
    french_swiss: 'fr-CH',
    french_canadian: 'fr-CA',
    french_belgian: 'fr-BE',
    german: 'de-DE',
    german_swiss: 'de-CH',
    italian: 'it-IT',
    italian_swiss: 'it-CH',
    romansh_swiss: 'rm-CH',
    dutch: 'nl-NL',
};
let legacyWarningsEnabled = true;
/**
 * Toggle the console.error warning that fires whenever the adapter maps a
 * legacy PSI key (e.g. 'french_swiss') to ISO. Defaults to enabled. Server
 * startup reads the LEGACY_LANGUAGE_WARNINGS env var and disables the warning
 * if set to 'false' so partner deployments can opt out during their migration
 * window. Client stays default-on.
 */
function setLegacyWarningsEnabled(enabled) {
    legacyWarningsEnabled = enabled;
}
/**
 * Coerce a value of unknown format (legacy key, ISO code, bare primary subtag,
 * or garbage) to IsoLocale.
 *
 * Order matters:
 *   1. Legacy lookup — calling parseIsoLocale on a legacy value would log a
 *      Sentry warning even though the legacy adapter is the exact place those
 *      values are expected to arrive during the deprecation window.
 *   2. Bare BCP 47 primary subtag (e.g. `'de'` → `'de-DE'`) — partner
 *      integrations commonly send just the primary subtag in `language_g`. We
 *      check this BEFORE parseIsoLocale because parseIsoLocale would otherwise
 *      report a spurious "unknown locale" via the Sentry pipeline for a
 *      perfectly reasonable input.
 *   3. parseIsoLocale — final fallback that reports unknowns via the locale
 *      reporter. Only true garbage (neither legacy nor recognizable subtag
 *      nor full ISO) reaches this branch and triggers the warning.
 */
function coerceLegacyOrIsoLanguage(input) {
    if (input == null)
        return locale_1.DEFAULT_ISO_LOCALE;
    const legacy = LEGACY_TO_ISO[input];
    if (legacy) {
        if (legacyWarningsEnabled) {
            console.error(`[locale] Legacy language key received: "${input}" (mapped to "${legacy}"). Partners should migrate to ISO codes.`);
        }
        return legacy;
    }
    const expanded = (0, locale_1.expandPrimarySubtag)(input);
    if (expanded)
        return expanded;
    return (0, locale_1.parseIsoLocale)(input) ?? locale_1.DEFAULT_ISO_LOCALE;
}
//# sourceMappingURL=legacy-language-adapter.js.map